import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import img_titulo from '../../assets/imgs_construcao_instalacao/IMG_ABRE_CONSTRUCAO.png';
import img_next from '../../assets/imgs_construcao_instalacao/NEXT_IMG_CONSTRUCAO.png';
import seta from '../../assets/imgs_construcao_instalacao/ARROW.png';

// Importando imagens dinamicamente
const importImages = async () => {
  const images = {};
  for (let i = 1; i <= 13; i++) {
        images[`img_${i}`] = require(`../../assets/imgs_construcao_instalacao/IMG_${i}_CONSTRUCAO.png`);
  }
  return images;
};

export default function ConstrucaoInstalacao() {
    // Força rolagem para o topo ao carregar o componente
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const [images, setImages] = useState({});
    
    useEffect(() => {
        importImages().then(setImages);
      }, []);

      useEffect(() => {
        const loadImages = async () => {
            const imgs = await importImages();
            setImages(imgs);
        };

        loadImages();
    }, []);

    const navigate = useNavigate();
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [nextText, setNextText] = useState("PRÓXIMO CONTEÚDO");

    const handleTransition = () => {
        setNextText("O PALÁCIO DO CONGRESSO NACIONAL");
        setIsTransitioning(true);
        setTimeout(() => {
            navigate('/Inauguracao'); 
        }, 1000); 
    }

    const [visibleSection, setVisibleSection] = useState('INTRODUÇÃO');

    const toggleVisibility = (paragrafo) => {
        setVisibleSection(paragrafo);
    };

  return (
    <div className="w-full bg-white flex flex-col justify-center font-medium font-['Lato']">
      <Header cor='branca' />

      <div 
          class="w-full h-auto bg-cover bg-center"
          style={{ backgroundImage: `url(${img_titulo})` }}
      >
        {/* OVERLAY */}
        <div className="w-full h-screen flex flex-col justify-center pt-64 gap-64 pl-24 pr-[33.19vw] pb-28 bg-black/40">
            <div class="w-[56.11vw]">
              <div className="w-[56.11vw] flex-col justify-center items-start inline-flex">
                  <div className="w-[37.56vw] text-white text-3xl font-light font-lato">O PALÁCIO DO CONGRESSO NACIONAL</div>
                  <div className="w-[56.11VW] h-10 text-white text-[45px] font-bold font-futura-bold">CONSTRUÇÃO E INSTALAÇÃO</div>
              </div>

              <div class="w-[28.58vw] pt-6">
                <div class="pb-1 text-white text-xl font-medium font-['Lato']">Marcos Magalhães</div>
                <div class="w-[28.58vw] h-[0px] border border-white"></div>
                <div class="text-white text-base font-light font-['Lato']">Historiador e Consultor Legislativo</div>
              </div>
            </div>

            <div class="w-[34.7vw]"> 
              <div className="w-[34.7vw] text-white text-base font-medium font-['Lato'] [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">Vista da Praça dos 3 poderes em croqui de Oscar Niemeyer - 1957<br/>Revista Brasília nº 12</div>
            </div>
        </div>
      </div>

      <div
            className="w-full min-h-screen bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_1})` }}
        >
          {/* OVERLAY */}
          <div className="w-full min-h-screen py-[23vh] pl-[7vw] pr-[11.3vw] bg-black/80">
            <div className="w-full box-border gap-5 text-white flex items-start">
                <div className="flex flex-col gap-4 mb-4">
                    <p
                        onClick={() => toggleVisibility('INTRODUÇÃO')}
                        className={`cursor-pointer text-lg font-normal font-['Lato'] ${
                            visibleSection === 'INTRODUÇÃO' ? 'text-white' : 'text-white/40'
                        }`}
                    >
                        INTRODUÇÃO
                    </p>
                </div>

                {visibleSection === 'INTRODUÇÃO' && (
                    <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
                      Durante o período da construção, Brasília teve presença regular na pauta do Parlamento. Um motivo adicional incentivou a participação do Senado naquela “aventura radical”: a nova sede do Legislativo.<br/><br/>As obras do Congresso Nacional, a construção mais complexa da nova capital, iniciaram em quatro de janeiro de 1958, seis meses antes do início do Palácio do Planalto e do STF. Divisava-se, então, o aspecto final do Palácio da Alvorada e do Brasília Palace Hotel, os primeiros edifícios monumentais da cidade, iniciados em fevereiro de 1957. Todos assinados pelo arquiteto Oscar Niemeyer.
                      <br/><br/>Os Senadores formaram, em agosto de 1958, a Comissão de Estudos do Projeto destinado ao Senado Federal. Aproveitando a recente experiência do concurso de projetos para a reforma do Palácio Monroe (1953), a Comissão propunha-se a “tomar conhecimento dos planos e projetos do imóvel que está sendo construído em Brasília, verificar se atendem as necessidades e conveniências do Senado, apresentar sugestões, se for o caso, e acompanhar a construção”. Não obstante não tenha interferido na concepção do projeto em sua origem, a interlocução que se estabeleceu em reuniões conjuntas de Niemeyer, sua equipe e os Senadores introduziu várias alterações. E motivou que os Senadores acompanhassem a obra, visitando-a repetidas vezes.
                      <br/><br/>Parece difícil estimar a importância do urbanismo de Lúcio Costa e da arquitetura de Niemeyer para a história política do país. Propiciaram uma experiência única na história do Senado e da Câmara. Desde o seu surgimento, as duas Casas do Legislativo nacional habitavam locais diferentes. O gênio arquitetônico as uniu. Permanece em aberto a compreensão desta dinâmica espacial nos momentos cruciais da nossa história recente, até mesmo no cotidiano das relações entre as duas Casas do Parlamento.
                    </div>
                )}
            </div>
          </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-end pb-28 pl-40 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_1})`}}
        >
          <div className="w-[23.82vw] text-white text-base font-medium font-['Lato']">JK, Israel Pinheiro e Niemeyer revisam plantas do Plano Piloto no Palácio do Planalto.<br/>Circa 1960<br/>Acervo do Arquivo Nacional</div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-start pt-28 pl-40 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_2})`}}
        >
          <div className="w-[27.4vw] text-black text-base font-medium font-['Lato']">Croquis do Plano Piloto de Brasília por Lúcio Costa - 1957<br/>Revista Brasília nº 12</div>
        </div>

        <div
            className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_3})`}}
        >
            {/* OVERLAY */}
            <div className="w-full h-auto flex flex-col py-72 pl-56 pr-[55.72vw] bg-[#5a6e64]/80">
              <div className="w-[23.3vw] h-36 text-white text-xl font-bold font-['Lato']">Nasceu do gesto primário de quem assinala um lugar ou dele toma posse: dois eixos cruzando-se em ângulo reto, ou seja, o próprio sinal da Cruz. <br/><br/>Projeto Lúcio Costa, 1957</div>
            </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-end pl-44 pb-32 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_3})`}}
        >
          <div className="w-[43.81vw] text-white text-base font-medium font-['Lato']">Cruzamento dos Eixos Monumental e Rodoviário. Obras de construção de Brasília l – 1957<br/>Mário Fontenelle <br/>Arquivo Público do Distrito Federal</div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-start pl-40 pt-32 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_4})`}}
        >
          <div className="w-[31.51vw] text-black text-base font-medium font-['Lato']">Croquis do Plano Piloto de Brasília por Lúcio Costa - 1957<br/>Revista Brasília nº 12</div>
        </div>

        <div 
            class="w-full min-h-screen flex flex-col py-96 px-56 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_5})`}}
        >
          <div className="w-[64.32vw] text-black text-xl font-medium font-['Lato']">
            “Tomando a palavra, o Sr. Oscar Niemeyer manifestou seu ponto de vista, de que não havia um edifício para o Senado e um para a Câmara, mas um só para o Congresso, não comportando limites exatos de separação entre uma Casa e outra. Dentro da concepção com que fora elaborado o projeto, os halls deviam ser partes comuns ao Senado e à Câmara ... Qualquer separação que se fizesse, tendo por fim o estabelecimento de um limite entre as duas Casas, seria artificial. 
            A ser feita, se-lo-ia contra a sua opinião”<br/><br/>Ata de Reunião da Comissão de Estudos do Projeto destinado ao Senado Federal, 31 de outubro de 1959.
          </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-end pl-40 pb-24 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_5})`}}
        >
          <div className="w-[39.71vw] text-black text-base font-medium font-['Lato']">Corte transversal da cupula do Senado Federal em croqui de Oscar Niemeyer - 1957<br/>Revista Brasília nº 12</div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-center pl-40 pb-12 bg-cover bg-fixed bg-center"
            style={{ backgroundImage: `url(${images.img_6})`}}
        >
          <div className="w-[28.58vw] text-black text-base font-medium font-['Lato']">Congresso Nacional em croquis de Oscar Niemeyer - 1957<br/>Revista Brasília nº 12</div>
        </div>

        <div
            className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_7})`}}
        >
            {/* OVERLAY */}
            <div className="w-full h-auto flex flex-col py-96 pl-56 bg-[#5a6e64]/80">
              <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
                “A idéia, enfim, de localizar a sede dos três poderes fundamentais, não no centro do núcleo urbano, mas na sua extremidade, sobre o terrapleno triangular, como palma de mão que se abrisse além do braço estendido da esplanada, onde se alinham os ministérios. Assim sobrelevados, e tratados com dignidade e apuro arquitetônicos, em contraste com a agreste natureza circundante, eles se oferecem simbolicamente à Nação e parecem dizer ao povo: votai, que o poder é vosso!”<br/><br/>Juscelino Kubitscheck, 18.09.1959
              </div>
            </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-start pl-40 pt-32 bg-cover bg-fixed bg-center"
            style={{ backgroundImage: `url(${images.img_7})`}}
        >
          <div className="w-[35.67vw] text-black text-base font-medium font-['Lato']">Juscelino e convidados visitam as obras do Congresso Nacional - 1958<br/>Acervo do Arquivo Nacional</div>
        </div>

        <div
            className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_8})`}}
        >
            {/* OVERLAY */}
            <div className="w-full h-auto flex flex-col py-96 pl-56 bg-[#f6f8ee]/90">
              <div className="w-[64.32vw] text-black text-xl font-medium font-['Lato']">
                ”Ali, à frente do visitante, erguem-se conjuntos soberbos, como o Palácio dos Despachos, o do Congresso, a fileira dos Ministérios, os blocos residenciais, e à frente deles as estacas marcam datas de menos de um ano: tudo isso surgido quase que por milagre, do esforço e do engenho de um número relativamente pequeno de “paus-de-arara” que, sob sua indumentária típica e seus gestos de câmara lenta, escondem energias insuspeitadas”. <br/><br/>Samuel Wainer, editor do Última Hora, primeiro jornal a instalar redação em Brasília, 1960
              </div>
            </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-end pl-40 pb-20 bg-cover bg-fixed bg-center"
            style={{ backgroundImage: `url(${images.img_8})`}}
        >
          <div className="w-[28.32vw] text-white text-base font-medium font-['Lato']">Vista do Congresso em construção<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
        </div>

        <div
            className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_9})`}}
        >
            {/* OVERLAY */}
            <div className="w-full h-auto flex flex-col py-96 pl-56 bg-[#5a6e64]/80">
              <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
                “Em nome de tantos monumentos ilustres que povoam a nossa memória, graças vos sejam dadas por haverdes depositado confiança em vossos arquitetos para criar a cidade e em vosso povo para que lhe tenha amor ... 
                Esta Brasília sobre o seu gigantesco planalto é de certo modo a Acrópole sobre o seu rochedo ... Salve, capital intrépida, que recordas ao mundo estarem os seus monumentos ao serviço do espírito ... O que entra em jogo é imenso: trata-se, ao por a arquitetura ao serviço da Nação, de restituir-lhe a parte da alma, que perdera”. <br/><br/>André Malraux, em visita a Brasília, 25.08.1959
              </div>
            </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-end items-start pr-40 pt-24 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_9})`}}
        >
          <div className="w-[31.11vw] text-right text-white text-base font-medium font-['Lato']">Os Guerreiros, de Bruno Giorgi, ao fundo o Prédio do Congresso<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
        </div>

        <div
            className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_10})`}}
        >
            {/* OVERLAY */}
            <div className="w-full h-auto flex flex-col py-96 pl-56 bg-[#f6f8ee]/90">
              <div className="w-[64.32vw] text-black text-xl font-medium font-['Lato']">
                “Destacam-se no conjunto os edifícios destinados aos poderes fundamentais que, sendo em número de três e autônomos, encontraram no triângulo eqüilátero, vinculado à arquitetura da mais remota antiguidade, de forma elementar apropriada para contê-los. Criou-se então um terrapleno triangular, com arrimo, de pedra à vista, sobrelevado na campina circunvizinha a que se tem acesso pela própria rampa da auto-estrada que conduz à residência e ao aeroporto. Em cada ângulo dessa praça – Praça dos Três Poderes, poderia chamar-se – localizou-se uma das Casas, ficando as do governo e do Supremo Tribunal na Base, a do Congresso no vértice, com frente igualmente a uma ampla esplanada disposta num segundo terrapleno, de forma retangular e nível mais alto, de acordo com a topografia local, igualmente arrimado de pedras em todo o seu perímetro”. <br/><br/>Projeto Lúcio Costa, 1957
              </div>
            </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-end items-end pr-40 pb-24 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_10})`}}
        >
          <div className="w-[35.61vw] text-right text-black text-base font-medium font-['Lato']">Vista aérea da praça dos 3 poderes em croquis de Oscar Niemeyer - 1957<br/>Revista Brasília nº 12</div>
        </div>

        <div
            className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_11})`}}
        >
            {/* OVERLAY */}
            <div className="w-full h-auto flex flex-col py-96 pl-56 bg-[#5a6e64]/80">
              <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
                "Arquitetonicamente, um prédio como o do Congresso Nacional deve ser caracterizado pelos seus elementos fundamentais. Os dois plenários são no caso esses elementos, pois neles é que se resolvem os grandes problemas do país. Dar-lhes maior ênfase foi o nosso objetivo plástico, situando-os em monumental esplanada onde suas formas se destacam como verdadeiros símbolos do poder legislativo. Ao fundo, contrariando a linha horizontal da esplanada, erguem-se os blocos administrativos, que são os mais altos de Brasília." <br/><br/>Oscar Niemeyer, julho de 1957
              </div>
            </div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-start pl-24 pt-24 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_11})`}}
        >
          <div className="w-[31.11vw] text-black text-base font-medium font-['Lato']">O conjunto do Congresso em fase de acabamento - 1959<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-start items-center pl-24 pb-12 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_12})`}}
        >
          <div className="w-[31.11vw] text-black text-base font-medium font-['Lato']">Prédio do Congresso Nacional, Ministérios e Canteiro de obras da Catedral Metropolitana de Brasília, à direita. Via S1<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-end items-start pt-32 pr-24 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_13})`}}
        >
          <div className="w-[21.54vw] text-right text-black text-base font-medium font-['Lato']">A construção do conjunto do Congresso, ao lado os canteiros das obras - 1959<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
        </div>

        <div 
            class="w-full h-auto flex items-center bg-cover bg-center transition-all duration-1000"
            style={{ backgroundImage: `url(${img_next})` }}
        >
            {/* OVERLAY */}
            <div 
                class={`w-full h-screen pl-[7vw] pr-[33.19vw] pt-[45.90vh] pb-[45.80vh] transition-all duration-1000 ${
                    isTransitioning ? 'bg-black/40' : 'bg-[#abb5b0]/70'
                }`}
            >
                <div class="flex gap-6">
                    <div class="flex-col justify-center items-start inline-flex">

                        <div
                            className={`text-3xl font-light font-['Lato'] transition-colors duration-1000 ${
                                isTransitioning ? 'text-white' : 'text-black'
                            }`}
                        >
                            {nextText}
                        </div>
                        <div
                            className={`text-[45px] font-bold font-['Futura Std'] transition-colors duration-1000 ${
                                isTransitioning ? 'text-white' : 'text-black'
                            }`}
                        >
                            INAUGURAÇÃO
                        </div>
                    </div>
                    <img 
                        class="w-9 h-5 ml-6 mt-auto mb-6 cursor-pointer animate-moveRight transition-transform duration-500 hover:scale-110" 
                        src={seta} 
                        alt='seta'
                        onClick={handleTransition}
                        />
                </div>
            </div>
        </div>
    </div>
  );
}
